module.exports = __webpack_public_path__ + "img/pa-components.5f1684d5.png";